module.exports = __webpack_public_path__ + "static/media/kz.0c9413a2.svg";